export default __webpack_public_path__ + "static/media/PersImg14.17f31dc7.jpg";